export default __webpack_public_path__ + "images/onboarding/kaju-0e7e960490eaea2e7ccc9f86ae23b201.svg";